import axios from "axios";
import { API } from "../../utils/index";
const instance = axios.create();

export const getClients = async () => {
  const _endpoint = "client";
  const URL = `${API}/${_endpoint}`;
  return instance.get(URL);
};
